import { clsx } from "clsx";

function GameViewBar(props) {

	const style = {
		container: "flex justify-evenly border-1 m-2 p-1 rounded-full bg-zinc-100",
		button: "border-2 px-4 py-1 font-bold lg:text-base text-xs rounded-full cursor-pointer",
		selected: "text-white bg-sky-500 hover:bg-sky-600",
		neutral: "bg-gray-100 hover:text-sky-600 hover:border-sky-500"
	}

	function selectedView(view) {
		return props.gameView == view;
	}

	return (
		<div className={style.container}>
			<button
				aria-label="Reason to Play"
				className={clsx(style.button, selectedView('rtp') && style.selected, !selectedView('rtp') && style.neutral)}
				onClick={() => props.changeGameView('rtp')}>
					Reasons-2-Play
			</button>
			<button
				aria-label="Reason in Play"
				className={clsx(style.button, selectedView('rip') && style.selected, !selectedView('rip') && style.neutral)}
				onClick={() => props.changeGameView('rip')}>
					Reason-in-Play
			</button>
			<button
				aria-label="Common Ground"
				className={clsx(style.button, selectedView('cg') && style.selected, !selectedView('cg') && style.neutral)}
				onClick={() => props.changeGameView('cg')}>
					Common Ground
			</button>
		</div>
	);
}

export default GameViewBar;
